import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f866462"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebarButton" }
const _hoisted_2 = { class: "sidebarUserMenu" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_user_home" }, null, -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_loyalty-point" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_lokacija-priljubljena" }, null, -1))
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_waste_containers" }, null, -1))
const _hoisted_9 = { key: 2 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_waste_containers" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_car" }, null, -1))
const _hoisted_12 = { key: 3 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_denarnica" }, null, -1))
const _hoisted_14 = { key: 4 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_connected_accounts" }, null, -1))
const _hoisted_16 = { key: 5 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_waste_containers" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_user" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_campaign_edit" }, null, -1))
const _hoisted_20 = { key: 6 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_document" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        class: "showSidebar icon-warpit_icon_menu-open sidebar",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('sidebar-toggled')))
      })
    ]),
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: { name: 'MySuperCity' } }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("city.my_city")), 1)
          ]),
          _: 1
        })
      ]),
      (_ctx.loyaltyEnabled)
        ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
            _createVNode(_component_router_link, { to: { name: 'MyPointsOverview' } }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createTextVNode(_toDisplayString(_ctx.$t("user.my_points")), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: { name: 'MyLocations' } }, {
          default: _withCtx(() => [
            _hoisted_6,
            _createTextVNode(_toDisplayString(_ctx.$t("user.my_locations")), 1)
          ]),
          _: 1
        })
      ]),
      (_ctx.wasteSmsNotification)
        ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
            _createVNode(_component_router_link, { to: { name: 'MyWaste' } }, {
              default: _withCtx(() => [
                _hoisted_8,
                _createTextVNode(_toDisplayString(_ctx.$t("user.my_waste")), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.wasteManagement || _ctx.wasteSubscriberCollection)
        ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
            _createVNode(_component_router_link, {
              to: {
          name: _ctx.wasteSubscriberCollection
            ? 'PrivateWasteTimeline'
            : 'PrivateWasteTakeaway',
        }
            }, {
              default: _withCtx(() => [
                _hoisted_10,
                _createTextVNode(_toDisplayString(_ctx.$t("user.my_waste")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: { name: 'MyVehicles' } }, {
          default: _withCtx(() => [
            _hoisted_11,
            _createTextVNode(_toDisplayString(_ctx.$t("user.my_vehicles")), 1)
          ]),
          _: 1
        })
      ]),
      (_ctx.paymentEnabled)
        ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
            _createVNode(_component_router_link, { to: { name: 'PaymentOpen' } }, {
              default: _withCtx(() => [
                _hoisted_13,
                _createTextVNode(_toDisplayString(_ctx.$t("user.my_payments")), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.paymentEnabled)
        ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
            _createVNode(_component_router_link, { to: { name: 'RelatedAccounts' } }, {
              default: _withCtx(() => [
                _hoisted_15,
                _createTextVNode(_toDisplayString(_ctx.$t("user.related_accounts")), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.myWasteEnabled)
        ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
            _createVNode(_component_router_link, { to: { name: 'WasteManagement' } }, {
              default: _withCtx(() => [
                _hoisted_17,
                _createTextVNode(_toDisplayString(_ctx.$t("user.my_waste")), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: { name: 'MyProfile' } }, {
          default: _withCtx(() => [
            _hoisted_18,
            _createTextVNode(_toDisplayString(_ctx.$t("user.my_profile")), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: { name: 'MyConsents' } }, {
          default: _withCtx(() => [
            _hoisted_19,
            _createTextVNode(_toDisplayString(_ctx.$t("user.my_consents")), 1)
          ]),
          _: 1
        })
      ]),
      (_ctx.eApplicationsEnabled)
        ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
            _createVNode(_component_router_link, { to: { name: 'MyApplications' } }, {
              default: _withCtx(() => [
                _hoisted_21,
                _createTextVNode(_toDisplayString(_ctx.$t("forms.my_form.title")), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}